var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75S14.825 1.25 10 1.25Zm0 16.25c-4.133 0-7.5-3.367-7.5-7.5S5.867 2.5 10 2.5s7.5 3.367 7.5 7.5-3.367 7.5-7.5 7.5Zm4.283-8.375-5.891-3.4a1.008 1.008 0 0 0-1.017 0 1.011 1.011 0 0 0-.508.875v6.8a1.008 1.008 0 0 0 1.017 1.008c.174 0 .35-.041.508-.133l5.891-3.4c.317-.183.509-.508.509-.875s-.192-.692-.509-.875Zm-6.158 3.867V7.008L13.308 10l-5.183 2.992Z",
    fill: "current"
  })));
};
export default SvgPlay;